/*jslint white: true, nomen: true */
/*global angular, $, communityId */
(function() {
  'use strict';

	angular.module('app.homepage')
	.controller("homepageCtrl", [
		'$scope',
		'$timeout',
		'DeviceService',
		'$window',
		'CommunitiesListDataService',
		'TestimonialListDataService',
		'$rootScope',
		'regionStorageFactory',
		function($scope,
			$timeout,
			DeviceService,
			$window,
			CommunitiesListDataService,
			TestimonialListDataService,
			$rootScope,
			regionStorageFactory
		) {

			TestimonialListDataService.getTestimonials().then(function(result){
				$scope.testimonials = result.data.testimonials.filter(function(testimonial) {
					return testimonial.style !== 'video';
				});
			});

			CommunitiesListDataService.getRegions().then(function(result){
				$scope.regionDropdown = result.regions;
			});

	// 		$scope.toggled = function(open) {
	// 		  if (DeviceService.check() == 'phone' && open) {
	// 		    $('html, body').animate({
	// 		      scrollTop: $('section#welcome-home .col-left button').offset().top - parseInt(75, 10)
    //       }, 750);
	// 		  }
    //   }

			var switchSlides = function() {
				$scope.slides = [];

	        	// if(DeviceService.check() == 'phone'){
	        	// 	$scope.slides = $scope.mobileSlides;
	        	// }else{
				// 	$scope.slides = $scope.homepageSlides;
	        	// }
				$scope.slides = $scope.homepageSlides;
	            $scope.$apply();
			};

			angular.element($window).bind('load resize', switchSlides);

			var heroVideoMode = null; // 'desktop' | 'mobile'
			var desktopMatch = window.matchMedia('(min-width:768px)');
			var reducedMotionMatch = window.matchMedia('(prefers-reduced-motion: reduce)');
			var canAutoplay = function() { return !reducedMotionMatch.matches; };

			var setHeroVideoSource = function() {
				var container = document.getElementById('hero-video-container');
				var video = document.getElementById('hero-video');
				if (!container || !video) { return; }
				var isDesktop = desktopMatch.matches;
				var mode = isDesktop ? 'desktop' : 'mobile';
				if (heroVideoMode === mode) { return; }
				heroVideoMode = mode;
				var prefix = mode === 'desktop' ? 'desktop' : 'mobile';
				var poster = container.getAttribute('data-' + prefix + '-poster');
				var mp4 = container.getAttribute('data-' + prefix + '-mp4');
				var webm = container.getAttribute('data-' + prefix + '-webm');
				video.poster = poster || '';
				video.innerHTML = '<source src="' + mp4 + '" type="video/mp4"><source src="' + webm + '" type="video/webm">Your browser does not support the video tag.';
				video.load();
				if (canAutoplay()) { video.play(); }
				var posterImg = document.getElementById('poster-img');
				if (posterImg && poster) { posterImg.src = poster; }
			};

			angular.element($window).bind('load resize', setHeroVideoSource);

			// this hack makes me physically sick but it's the only thing I can think of
			// to overcome a browser bug where autoplay is not honored if the dom makes
			// any change to the <video> element. Which, of course, we need to do. -wo
			$timeout(function(){
				switchSlides();
				$timeout(function(){
					setHeroVideoSource();
					var video = document.getElementById('hero-video');
					if (video && canAutoplay()) {
						video.play();
					}
				});
			});

	        $scope.closePopovers = function(event){
	        	if($(event.target).closest('.pin').length < 1){
	        		$rootScope.$broadcast('closePopOvers',{id:null});
	        	}
	        }

	        $scope.mobileTrigger = function(e){
	        	if(DeviceService.check() == 'phone'){
	        		e.preventDefault();
	        		var v = document.getElementById('hero-video');
	        		if (v && canAutoplay()) { v.play(); }
	        	}
	        };

			$scope.generatePopoverContent = function(pin){
				return '<a href="/find-new-homes/' + pin.seo + '/communities"><i class="fa fa-search"></i> SEARCH</a>';
			}

	        $scope.mobileSlides = [
				// {
				// 	type: 'image',
				// 	slideMobile: true,
				// 	img: '/images/site/homepage/slides/mobile-background.jpg',
				// 	cta: 'FIND YOUR HOME',
				// 	ctaLink: '/images/site/homepage/slides/fischer.mp4'
				// }
	        ];

	        $scope.pins = [
	        	{
	        		title: 'Columbus, OH',
	        		seo: 'columbus/ohio',
	        		top: '25%',
	        		left: '65.5%'
	        	},
	        	{
	        		title: 'Indianapolis, IN',
	        		seo: 'indianapolis/indiana',
	        		top: '28%',
	        		left: '50%'
	        	},
	        	{
	        		title: 'Atlanta, GA',
	        		seo: 'atlanta/georgia',
	        		top: '63%',
	        		left: '66%'
	        	},
	        	{
	        		title: 'Cincinnati + Northern Kentucky',
              		seo: 'cincinnati-area/ohio',
	        		top: '31.5%',
	        		left: '58%'
	        	},
	        	{
	        		title: 'Dayton, OH',
	        		seo: 'dayton/ohio',
	        		top: '27%',
	        		left: '58%'
				},
				{
					title: 'St. Louis, MO',
					seo: 'st-louis/missouri',
					top: '37%',
					left: '29%'
				},
				{
					title: 'Lexington, KY',
					seo: 'lexington/kentucky',
					top: '38%',
					left: '59%'
				},
				{
					title: 'Louisville, KY',
					seo: 'louisville/kentucky',
					top: '38%',
					left: '52%'
				},
				{
					title: 'Northwest Florida',
					seo: 'northwest-florida',
					top: '80.5%',
					left: '60%'
				},
				{
					title: 'Raleigh, NC',
					seo: 'raleigh/north-carolina',
					top: '48%',
					left: '90%'
				}
	        ];

	        $scope.parseRegion = function(template, section) {
	          if (template === null || regionStorageFactory.get()) {
	            var region = regionStorageFactory.get();
	            $window.location.href = region.url + section;
	          } else {
	            $scope.$broadcast('triggerModal', {
	              path: template,
	              section: section
	            });
	          }
	        };

			$scope.homepageSlides = [
			{
				id: 0,
				type: 'video',
				classname: 'video',
				title: 'welcoming spaces',
				cta: 'FIND YOUR NEW HOME'
			}
			];

			var menuHeader = document.getElementsByClassName('navbar-header')[0];
			var menuToggle = document.getElementsByClassName('navbar-toggle')[0];

			var menuToggleObserver = new MutationObserver((mutationsList, observer) => {
				var classList = menuToggle.classList;

				if(!classList.contains('collapsed')) {
					menuHeader.style.backgroundColor = 'black' ;
					menuHeader.classList.add('open');
				} else {
					menuHeader.style.backgroundColor = 'transparent';
					menuHeader.classList.remove('open');
				}
			})

			var menuToggleObserverConfig = {attributes: true, attributeFilter: ['class']};

			menuToggleObserver.observe(menuToggle, menuToggleObserverConfig);

			if(!menuToggle.classList.contains('collapsed')){
				menuHeader
			}


			menuHeader.classList.remove('dark-scroll');

			window.addEventListener('scroll', function () {

				var scrollPosition = window.scrollY;
				var scrollThreshold = window.innerHeight - 120;

				if (scrollPosition > scrollThreshold) {
				  menuHeader.classList.add('dark-scroll');
				} else {
				  menuHeader.classList.remove('dark-scroll');
				}
			  });



		}
	]);

}());
